module.exports = __webpack_public_path__ + "static/media/php.7cd861eb.svg";